import {
  clickResponseTimeMetric,
  componentRenderMetric,
  createPodMonitoringSchema,
  deadClickMetric,
  rageClickMetric,
  redirectionSuccessMetric,
} from "@repo/monitoring";
import { amcPdpApiMetrics, amcPdpApiMonitors } from "./amcPdpApiMonitoring";

export const amcPdpMonitoringSchema = createPodMonitoringSchema({
  schemaId: "bfl-amc-pdp-app.new-relic.v1",
  pod: "bfl-amc-pdp-app",
  metrics: [
    ...amcPdpApiMetrics,
    clickResponseTimeMetric,
    redirectionSuccessMetric,
    deadClickMetric,
    rageClickMetric,
    componentRenderMetric,
  ],
  apiMonitors: amcPdpApiMonitors,
});
